import RecordsBonusesTable from './RecordsBonusesTable';

export default RecordsBonusesTable;
